import { CouriersApp } from './couriers-app';

customElements.define('couriers-app', CouriersApp);
